  // 親要素のクラス切替
(function($){

  $.fn.toggleParentClass = function(event, selector, options) {
    options = options||{};
    this.on(event,function(){
      if ($(this).is(":checked")) {
        $(this).parents(selector).addClass("checked");
      } else {
        $(this).parents(selector).removeClass("checked");
      }
      if (!!options.callback) options.callback.apply(this);
    });
    this.last().trigger(event);
    return this;
  }

})(jQuery);
